import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex';

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faFile,
  faIndustry,
  faInfo,
  faSlidersH,
  faTable,
  faInfoCircle,
  faFileUpload,
  faArrowDown,
  faArrowUp,
  faSpinner, faSave, faLink, faCode, faBookmark, faExchangeAlt, faTrash
} from '@fortawesome/free-solid-svg-icons'
import { BootstrapVue } from 'bootstrap-vue'
import stores from './store';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
library.add(faFile)
library.add(faIndustry)
library.add(faInfo)
library.add(faTable)
library.add(faInfoCircle)
library.add(faSlidersH)
library.add(faFileUpload)
library.add(faArrowDown)
library.add(faArrowUp)
library.add(faSpinner)
library.add(faSave)
library.add(faLink)
library.add(faCode)
library.add(faBookmark)
library.add(faExchangeAlt)
library.add(faTrash)

Vue.config.productionTip = false
const store = new Vuex.Store(stores);

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
